'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var isNumber = (0, _ramda.allPass)([(0, _ramda.compose)(_ramda.not, isNaN), (0, _ramda.is)(Number), function (x) {
  return Number.isInteger(x);
}]);

var makeValidator = (0, _ramda.compose)(_ramda.allPass, (0, _ramda.map)((0, _ramda.compose)((0, _ramda.apply)(_ramda.propSatisfies), _ramda.reverse)), _ramda.toPairs);

var validateObject = function validateObject(validations, obj) {
  return (0, _ramda.allPass)([(0, _ramda.is)(Object), makeValidator(validations)], obj);
};

var isStringWithLength = function isStringWithLength(min, max) {
  return (0, _ramda.allPass)([(0, _ramda.is)(String), (0, _ramda.compose)((0, _ramda.both)((0, _ramda.gte)(_ramda.__, min), (0, _ramda.lte)(_ramda.__, max)), _ramda.length)]);
};

var uuidRegex = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;

var isArrayWithLength = function isArrayWithLength(len) {
  return (0, _ramda.both)(_ramda.isArrayLike, (0, _ramda.compose)((0, _ramda.equals)(len), _ramda.length));
};
var inRange = function inRange(min, max) {
  return (0, _ramda.both)((0, _ramda.gte)(_ramda.__, min), (0, _ramda.lte)(_ramda.__, max));
};

var questionnaire1 = (0, _ramda.allPass)([_ramda.isArrayLike, (0, _ramda.compose)((0, _ramda.equals)(40), _ramda.length), (0, _ramda.all)(inRange(0, 4))]);
var questionnaire2 = (0, _ramda.allPass)([_ramda.isArrayLike, (0, _ramda.compose)((0, _ramda.equals)(28), _ramda.length), (0, _ramda.all)((0, _ramda.allPass)([isArrayWithLength(2), (0, _ramda.all)(inRange(0, 4)), function (pair) {
  return pair[0] !== pair[1] || pair[0] === 0;
}]))]);

exports.default = {
  isNumber: isNumber,
  isNumberInRange: (0, _ramda.curryN)(3, function (min, max, num) {
    return (0, _ramda.both)(isNumber, inRange(min, max))(num);
  }),
  validateObject: (0, _ramda.curryN)(2, validateObject),
  isStringWithLength: (0, _ramda.curryN)(2, isStringWithLength),
  username: isStringWithLength(4, 24),
  password: isStringWithLength(6, 30),
  name: isStringWithLength(1, 60),
  company: isStringWithLength(1, 60),
  age: (0, _ramda.allPass)([isNumber, (0, _ramda.gte)(_ramda.__, 0), (0, _ramda.lte)(_ramda.__, 125)]),
  sex: (0, _ramda.contains)(_ramda.__, ['M', 'F']),
  email: (0, _ramda.allPass)([isStringWithLength(5, 254), (0, _ramda.contains)('@')]),
  expirationDays: (0, _ramda.either)((0, _ramda.equals)(-1), (0, _ramda.allPass)([isNumber, inRange(1, 100)])),
  uuid: (0, _ramda.bind)(uuidRegex.test, uuidRegex),
  questionnaire1: questionnaire1,
  questionnaire2: questionnaire2,
  answers: (0, _ramda.allPass)([(0, _ramda.compose)((0, _ramda.equals)(2), _ramda.length), (0, _ramda.compose)(questionnaire1, _ramda.head), (0, _ramda.compose)(questionnaire2, _ramda.head, _ramda.tail)]),
  finishedQuestionnaire1: (0, _ramda.allPass)([questionnaire1, (0, _ramda.compose)((0, _ramda.equals)(0), _ramda.length, (0, _ramda.filter)((0, _ramda.equals)(0)))]),
  finishedQuestionnaire2: (0, _ramda.allPass)([questionnaire2, (0, _ramda.compose)((0, _ramda.equals)(0), _ramda.length, (0, _ramda.filter)((0, _ramda.equals)(0)), _ramda.flatten)])
};


//////////////////
// WEBPACK FOOTER
// ./~/common/dist/validations.js
// module id = 2345
// module chunks = 0